import { SeriesTypeEnum } from "../../series/interface/type";

import { BaseWordCloudChart } from "./base/base";

import { registerWordCloudSeries, registerWordCloudShapeSeries } from "../../series/word-cloud/word-cloud";

import { Factory } from "../../core/factory";

import { BaseWordCloudChartSpecTransformer } from "./base/word-cloud-base-transformer";

import { registerMarkTooltipProcessor } from "../../component/tooltip/processor/mark-tooltip";

export class WordCloudChart extends BaseWordCloudChart {
    constructor() {
        super(...arguments), this.transformerConstructor = BaseWordCloudChartSpecTransformer, 
        this.type = "wordCloud", this.seriesType = SeriesTypeEnum.wordCloud;
    }
}

WordCloudChart.type = "wordCloud", WordCloudChart.seriesType = SeriesTypeEnum.wordCloud, 
WordCloudChart.transformerConstructor = BaseWordCloudChartSpecTransformer;

export const registerWordCloudChart = () => {
    registerMarkTooltipProcessor(), registerWordCloudSeries(), Factory.registerChart(WordCloudChart.type, WordCloudChart);
};

export const registerWordCloudShapeChart = () => {
    registerWordCloudShapeSeries(), registerMarkTooltipProcessor(), registerWordCloudSeries(), 
    Factory.registerChart(WordCloudChart.type, WordCloudChart);
};
//# sourceMappingURL=word-cloud.js.map
